import { gql } from "@apollo/client";

export const SEND_FEEDBACK = gql`
    mutation SendFeedback($input: SendFeedbackInput!) {
        sendFeedback(input: $input)
    }
`;
